import React from 'react';
import css from './NewsSingleCategory.module.scss';
import classnames from 'classnames';
import { A } from '../../../../../hybrid/wrappers';

const Wrapper = (props) => {
    const { onClick, children } = props;
    if (onClick) {
        return <div {...props}>{children}</div>;
    }
    return <A {...props}>{children}</A>;
};
function NewsSingleCategory({ category, currentId, onClick }) {
    return (
        <Wrapper
            onClick={onClick}
            href={
                onClick
                    ? null
                    : category?.id
                    ? {
                          as: `/news/category/${category.seo_url}`,
                          pathname: `/news/category/[id]`,
                          query: { id: category.seo_url }
                      }
                    : `/news`
            }
        >
            <div
                className={classnames(
                    css.newsCategoriesSingle,
                    currentId == category.seo_url ? css.newsCategoriesSingleActive : ''
                )}
                key={category.id}
            >
                {category.title}
            </div>
        </Wrapper>
    );
}

export default NewsSingleCategory;
